// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"337":"335894b4b82f6d35","632":"12865823584c4b65"}[chunkId] + ".js";
};